import { render, staticRenderFns } from "./loading-component.vue?vue&type=template&id=7f850335&scoped=true&"
import script from "./loading-component.vue?vue&type=script&lang=ts&"
export * from "./loading-component.vue?vue&type=script&lang=ts&"
import style0 from "./loading-component.vue?vue&type=style&index=0&id=7f850335&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f850335",
  null
  
)

export default component.exports